import { useQuery } from '@tanstack/react-query'
import { extranetUsersQueryKeyFactory } from './users.queries'
import { api } from '../../services/HttpService'

export const useCurrentUser = () => {

  const { data, isLoading } = useQuery({
    queryKey: extranetUsersQueryKeyFactory.getCurrentUser(),
    queryFn: async () => await api.users.getLoggedInUser(),
  })

  return {
    data,
    isLoading,
  }
}
